import FatalAccidentClaims from 'pages/fatal-accident-claims/FatalAccidentClaims.vue';
import DependencyRoutes from 'pages/fatal-accident-claims/dependency/routes';
import EstateRoutes from 'pages/fatal-accident-claims/estate/routes';

export default [
    {
        name: 'fatal',
        path: '/fatal-accidents/:id(\\d+)?',
        component: FatalAccidentClaims,
        children: [
            DependencyRoutes,
            EstateRoutes,
        ],
    },
];



// WEBPACK FOOTER //
// ./src/pages/fatal-accident-claims/routes.js